import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloseCircle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "feather feather-x-circle",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 10
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 15,
			y1: 9,
			x2: 9,
			y2: 15
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 9,
			y1: 9,
			x2: 15,
			y2: 15
		})
	]
});
const ForwardRef = forwardRef(SvgCloseCircle);
export { ForwardRef as ReactComponent };
